import { defineAsyncComponent } from 'vue';
import { openModal } from '@plugins/modal';

export const openInviteFriendsModal = () => {
    openModal(defineAsyncComponent(() => import('@components/ModalShareFriendInvitation')));
};
